module.exports = __webpack_public_path__ + "assets/img/esera.e9415212.png";